import handImg from "../assets/images/hand_surgery.png";
import wristImg from "../assets/images/wrist_surgery.png";
import peripheralImg from "../assets/images/peripheral_surgery.png";
import branchialImg from "../assets/images/branchial_surgery.png";

export const SERVICES_DATA = [
  {
    title: "Centre for Hand Surgery",
    subtitle: "Fractures · Tendon Repairs · Reconstructive",
    desc: "Comprehensive care for injuries, deformities, and reconstructive procedures restoring full hand function.",
    img: handImg, // ✅ FIXED
    conditions: [
      "Hand fractures & dislocations",
      "Crush injuries & trauma",
      "Tendon & ligament injuries",
      "Congenital deformities",
      "Tumors & infections"
    ],
    procedures: [
      "Reconstructive surgery",
      "Finger reimplantation",
      "Tendon repair & grafting",
      "Nerve repair"
    ],
    color: "#3D3B8E",
    route: "/hand"
  },
  {
    title: "Centre for Wrist Surgery",
    subtitle: "Arthroscopy · Fractures · Instability",
    desc: "Advanced arthroscopic and open surgery for fractures, arthritis, carpal tunnel, and wrist instability.",
    img: wristImg, // ✅ FIXED
    conditions: [
      "Wrist fractures",
      "Carpal tunnel syndrome",
      "TFCC injuries",
      "Arthritis & instability"
    ],
    procedures: [
      "Wrist arthroscopy",
      "Ligament reconstruction",
      "Joint stabilization"
    ],
    color: "#2563EB",
    route: "/wrist"
  },
  {
    title: "Peripheral Nerve Surgery",
    subtitle: "Compression · Injury · Neuropathy",
    desc: "Specialized treatment for nerve compression, injury, and neuropathies affecting movement and sensation.",
    img: peripheralImg, // ✅ FIXED
    conditions: [
      "Nerve compression",
      "Nerve injuries",
      "Neuropathies",
      "Carpal tunnel"
    ],
    procedures: [
      "Nerve repair & grafting",
      "Nerve decompression",
      "Functional reconstruction"
    ],
    color: "#7C3AED",
    route: "/peripheral"
  },
  {
    title: "Brachial Plexus Surgery",
    subtitle: "Nerve Transfer · Muscle Transfer · Restoration",
    desc: "Expert microsurgical reconstruction for complex brachial plexus injuries restoring arm function.",
    img: branchialImg, // ✅ FIXED
    conditions: [
      "Birth palsy",
      "Traumatic injuries",
      "Nerve avulsion",
      "Paralysis"
    ],
    procedures: [
      "Nerve transfers",
      "Muscle transfers",
      "Functional restoration"
    ],
    color: "#059669",
    route: "/branchial"
  }
];